import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import { Iconify } from '../Minimal/src/components/iconify/iconify';

// ----------------------------------------------------------------------

export function ConfirmDialog({
  open,
  title,
  maxWidth = "xs",
  action,
  content,
  onClose,
  cancelLabel = "Cancel",
  closeIcon = false,
  ...other
}) {
  return (
    <Dialog fullWidth maxWidth={maxWidth} open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ pb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        {title}
        {closeIcon && (
          <IconButton onClick={onClose} size="small">
            <Iconify icon="mdi:close" width={20} height={20} />
          </IconButton>
        )}
      </DialogTitle>

      {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}

      <DialogActions>
        {action}

        <Button variant="outlined" color="inherit" onClick={onClose}>
          {cancelLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
